import type { Topic, TopicView } from '../domain/chat'

// Presentation helpers for a topic. A group uses its public.name, falling back
// to the topic name field; a p2p resolves to the peer's name from TopicView.peerName.
const topicTitle = (topic: Topic | TopicView, fallback: string): string => {
	if (topic.type === 'p2p') {
		const peerName = 'peerName' in topic ? topic.peerName : undefined
		return peerName?.trim() || fallback
	}
	const publicName = typeof topic.public?.name === 'string' ? topic.public.name.trim() : ''
	return publicName || topic.name || fallback
}

const topicInitials = (title: string): string => {
	const parts = title.trim().split(/\s+/).filter(Boolean)
	const first = parts[0]
	if (!first) return '?'
	const last = parts[parts.length - 1]
	if (parts.length === 1 || !last) return first.slice(0, 2).toUpperCase()
	return ((first[0] ?? '') + (last[0] ?? '')).toUpperCase()
}

export { topicTitle, topicInitials }
